/* eslint-disable react/prop-types */
import React from 'react';
import { HeaderSection } from '../PersonalBusinessReviewView.styles';

interface PersonalBusinessReviewHeaderProps {
  title?: string;
  description?: string;
}

export const PersonalBusinessReviewHeader = React.memo<PersonalBusinessReviewHeaderProps>(
  ({
    title = 'Review Personal Business Transactions',
    description = 'Review and classify transactions as personal or business expenses',
  }) => {
    return (
      <HeaderSection>
        <h2>{title}</h2>
        <p>{description}</p>
      </HeaderSection>
    );
  },
);

PersonalBusinessReviewHeader.displayName = 'PersonalBusinessReviewHeader';
